import { render, staticRenderFns } from "./index.vue?vue&type=template&id=221c0397&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=221c0397&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c0397",
  null
  
)

export default component.exports